/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import OmegaFooter from "views/OmegaBangles/Section/OmegaFooter";
import HeaderLinks from "components/Header/HeaderLinks.js";
import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);

export default function AboutUsPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();

  const currentUrl = "https://omegabangles.com/about-us";
  const seoTitle =
    "About Us | OMEGA BANGLES - Imitation Jewellery Manufacturer in India";
  const seoDescription =
    "Learn about OMEGA BANGLES, a trusted imitation jewellery manufacturer and exporter in India, known for quality, design, value, and customer satisfaction.";
  const seoKeywords =
    "About OMEGA BANGLES, imitation jewellery manufacturer, bangles manufacturer in India, jewellery exporter, wholesale bangles, artificial jewellery supplier";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "About Us - OMEGA BANGLES",
    url: currentUrl,
    description: seoDescription,
    mainEntity: {
      "@type": "Organization",
      name: "OMEGA BANGLES",
      url: "https://omegabangles.com",
      logo: ogImage,
    },
  };

  return (
    <div>
      <Helmet>
        {/* <title>About Us</title> */}
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="OMEGA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(aboutPageSchema)}
        </script>
      </Helmet>
      <Header
        brand="Home"
        links={<HeaderLinks dropdownHoverColor="warning" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "warning",
        }}
      />
      <Parallax
        image={require("assets/img/bg2.jpg").default}
        filter="dark"
        small
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter,
              )}
            >
              <h1 className={classe.title}>About Us</h1>
              <h4 style={{ color: "white" }}>
                Our aim is to give every customer much more than what he/she
                asks for in terms of quality, selection, value for money and
                customer service, by understanding local tastes and preferences
                and innovating constantly to eventually provide an unmatched
                experience in Bangles shopping.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <SectionDescription />
          <SectionTeam />
          <SectionOffice />
        </div>
      </div>
      <OmegaFooter />
    </div>
  );
}
